<template>
  <v-dialog v-model="dialog" content-class="invoice-dialog" @click:outside="close" @keydown.esc="close" scrollable>
    <v-toolbar>
      <v-toolbar-title>
        Tax Invoice
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close"><v-icon>clear</v-icon></v-btn>
    </v-toolbar>
    <v-card flat :loading="loading" class="invoice-dialog-card">
      <v-card-text>
        <v-form v-if="loaded" v-model="valid">
          <v-container style="paddng:0" fluid>
            <v-row no-gutters>
              <v-col cols="6">
                <v-select dense label="Customer" :items="customerList" v-model="customer.id"
                  outlined @change="onCustomerChange"></v-select>
                <v-container v-if="customer && customer.id" style="padding-top:0">
                  <v-row no-gutters class="customer-info">
                    <v-col cols="12"><v-icon>place</v-icon> {{ customer.address }}</v-col>
                    <v-col cols="12"><v-icon>email</v-icon> {{ customer.email }}</v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="6">
                <v-container class="py-0" fluid>
                  <v-row no-gutters>
                    <v-col cols="6"><v-text-field dense label="Invoice number" v-model="invoiceNo" outlined></v-text-field></v-col>
                    <v-col cols="6"><v-text-field dense label="GST number" v-model="entity.ird" disabled outlined></v-text-field></v-col>
                  </v-row>
                </v-container>
                <EditForm style="margin-top:-12px" col-margin-top="-8px" class="invoice-form" :items="fields"
                  @data-changed="onDataChanged" ref="editForm" creating />
              </v-col>
            </v-row>
            <v-divider style="margin-top:-12px; margin-bottom:12px"></v-divider>
            <v-row no-gutters>
              <v-col cols="12">
                <v-list>
                  <v-list-item>
                    <v-list-item-title style="background-color:lightgray">
                      <v-container>
                        <v-row no-gutters style="font-size:.9em; font-weight:bold;">
                          <v-col cols="3">Items</v-col>
                          <v-col cols="3">Description</v-col>
                          <v-col cols="1">Unit</v-col>
                          <v-col cols="1">Price</v-col>
                          <v-col cols="1">GST Rate</v-col>
                          <v-col cols="1">GST</v-col>
                          <v-col cols="1">Amount</v-col>
                          <v-col cols="1"></v-col>
                        </v-row>
                      </v-container>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-container>
                      <v-row no-gutters v-for="(item, idx) in invoiceItems" style="font-size:.9em;" :key="idx">
                        <v-col cols="3">{{ item.name }}</v-col>
                        <v-col cols="3"><v-text-field class="pr-2 invoice-input" v-model="item.description" @input="itemChanged = true"></v-text-field></v-col>
                        <v-col cols="1"><v-text-field class="pr-2 invoice-input" v-model="item.quantity" @input="itemChanged = true"></v-text-field></v-col>
                        <v-col cols="1"><v-text-field class="pr-2 invoice-input" v-model="item.price" @input="itemChanged = true"></v-text-field></v-col>
                        <v-col cols="1">
                          <v-select class="pr-2 invoice-input" :items="gstCodes" v-model="item.gst_percent" @change="itemChanged = true"></v-select>
                        </v-col>
                        <v-col cols="1">
                          <div style="margin-top:5px">${{ item.quantity * item.price *  parseFloat(item.gst_percent / 100) }}</div>
                        </v-col>
                        <v-col cols="1">
                          <div style="margin-top:5px"> ${{ (item.quantity * item.price * (1 + parseFloat(item.gst_percent) / 100)).toFixed(2) }}</div>
                        </v-col>
                        <v-col cols="1">
                          <v-btn icon color="red lighten-3" @click="deleteItem(idx)"><v-icon>delete_outline</v-icon></v-btn>
                        </v-col>
                      </v-row>
                      <v-row no-gutters style="font-size:.9em;">
                        <v-col cols="6">
                          <v-select class="pr-2 invoice-input" label="Add a product/service"
                            @change="addInvoiceItem" v-model="lastAddedProd" :items="prodServices"></v-select>
                        </v-col>
                      </v-row>
                      <v-row no-gutters style="font-size:.9em;">
                        <v-col offset="10" cols="2" class="text-start">
                          Total: ${{ totalAmount.toFixed(2) }}
                        </v-col>
                        <v-col offset="10" cols="2">
                          GST: ${{ totalGst.toFixed(2) }}
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-textarea dense label="Notes" v-model="notes" @change="changed = true" outlined></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels :disabled="paymentHistory.length === 0" hover>
                  <v-expansion-panel>
                    <v-expansion-panel-header><b>Payment history</b></v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container style="padding:0">
                        <v-row v-for="payment in paymentHistory" :key="payment.id" style="border-top:1px solid #ccc">
                          <v-col cols="5" offset="2">{{ payment.paid_time.split('.')[0].replace('T', ' ') | dateParse() | dateFormat('MMM DD, YYYY') }}</v-col>
                          <v-col cols="5">${{ payment.amount }} </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions style="border-top:1px solid #ccc">
        <v-container fluid style="padding-top:0">
          <v-row>
            <v-col offset="6" cols="3">
              <v-btn block :disabled="(!changed && !itemChanged) || !valid" @click="save">
                <v-icon left>done</v-icon> Save
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn block :disabled="!changed && !itemChanged" @click="reset">
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace, Getter } from 'vuex-class'
import EditForm from '@/components/public/EditForm'
import InvoiceService from '@/services/InvoiceService'
import CustomerService from '@/services/CustomerService'
import ProdServiceService from '@/services/ProdServiceService'

const SubModule = namespace('invoice')

@Component({
  components: {
    EditForm
  }
})
export default class InvoiceDetail extends Vue {
  dialog = false
  loaded = false
  loading = false
  accounts = []
  itemId = null
  changed = false
  itemChanged = false
  valid = false
  invoiceNo = null
  totalAmount = 0
  totalGst = 0
  notes = null
  lastAddedProd = null
  invoiceItems = []
  customer = {}
  gstCodes = [
    { text: '15%', value: 15 },
    { text: '100%', value: 100 },
    { text: 'zero', value: 0 }
  ]
  paymentHistory = []
  initCustomer = {}
  initInvoiceNo = null
  initInvoiceItems = []

  @Getter entity
  @SubModule.Getter fields
  @SubModule.Getter service
  @SubModule.Getter prodServices
  @SubModule.Getter('invoiceNo') invNo
  @SubModule.Getter('customer') customerObj
  @SubModule.Getter customerList
  @SubModule.Getter('notes') invNotes

  @SubModule.Action setFieldItems
  @SubModule.Action setFieldItemsNoSend
  @SubModule.Action setNotes

  onCustomerChange (item) {
    CustomerService.get(item)
      .then(resp => {
        this.customer = {
          id: resp.data.id,
          name: resp.data.name,
          address: resp.data.address.address,
          email: resp.data.email,
          phone: resp.data.phone
        }
        this.changed = true
      })
  }

  addInvoiceItem (item) {
    this.itemChanged = true
    ProdServiceService.get(item)
      .then(resp => {
        resp.data.quantity = 1
        resp.data.service = item
        this.invoiceItems.push(resp.data)
        this.lastAddedProd = null
      })
  }

  onDataChanged (item) {
    if (item.name === 'category') {
      const matched = item.items.filter(v => v.value === item.value)
      const gstRegistered = matched[0].gst_registered
      this.$nextTick(() => {
        if (gstRegistered) {
          this.setGstIncluded(true)
          this.enableGstIncluded(true)
        } else {
          this.setGstIncluded(false)
          this.enableGstIncluded(false)
        }
      })
    }
    this.changed = true
  }

  open () {
    this.dialog = true
    this.itemId = null
    this.initNew()
    InvoiceService.invoiceNo(this.entity.id)
      .then(resp => {
        this.invoiceNo = resp.data.invoice_no
      })
    this.loaded = true
  }

  formatDate (dt) {
    const m = dt.getMonth() + 1
    return `${dt.getFullYear()}-${m < 10 ? '0' + m : m}-${dt.getDate()}`
  }

  initNew () {
    this.$nextTick(() => {
      this.fields[0].value = ''
      this.fields.map(item => {
        this.$refs.editForm.setFieldValue(item.name, 'value', '')
      })
      this.$refs.editForm.setFieldValue('id', 'value', '')
      let issueDate = new Date()
      this.$refs.editForm.setFieldValue('issue_time', 'value', this.formatDate(issueDate))
      issueDate.setDate(issueDate.getDate() + 30)
      this.$refs.editForm.setFieldValue('due_date', 'value', this.formatDate(issueDate))
    })
    this.invoiceNo = null
    this.notes = null
    this.customer = {}
    this.invoiceItems = []
  }

  close () {
    this.dialog = false
    this.$emit('close-detail')
  }

  deleteItem (idx) {
    this.itemChanged = true
    this.invoiceItems.splice(idx, 1)
  }

  save () {
    this.loading = true
    if (!this.itemId || this.customer.id !== this.initCustomer.id) {
      this.$refs.editForm.setFieldValue('customer', 'value', this.customer.id)
    }
    if (!this.itemId || this.invoiceNo !== this.initInvoiceNo) {
      this.$refs.editForm.setFieldValue('invoice_no', 'value', this.invoiceNo)
    }
    if (!this.itemId || this.notes !== this.invNotes) {
      this.$refs.editForm.setFieldValue('notes', 'value', this.notes)
    }
    const data = this.$refs.editForm.save()

    if (!this.itemId || this.itemChanged) {
      data.items.push({ name: 'invoice_items', value: this.invoiceItems })
    }
    if (!this.itemId) {
      data.items.push({ name: 'entity', value: this.entity.id })
    }

    this.setFieldItems(data)
      .then(resp => {
        this.changed = false
        this.itemChanged = false
        this.$emit('update-detail')
        this.$emit('show-message', { message: 'Invoice saved!' })
        this.close()
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to save',
          error: resp.data.detail || resp.statusText
        })
      })
      .finally(() => {
        this.loading = false
      })
  }

  reset () {
    this.load(this.itemId)
  }

  load (pk) {
    this.loaded = false
    this.itemId = pk
    this.service.get(pk)
      .then(resp => {
        const data = resp.data
        const items = Object.keys(data).map(k => {
          return { name: k, value: data[k] }
        })
        this.setFieldItemsNoSend(items)
        this.invoiceNo = this.initInvoiceNo = this.invNo
        this.totalAmount = data.amount + data.gst
        this.totalGst = data.gst
        this.customer = data.customer
        Object.assign(this.initCustomer, this.customer)
        this.invoiceItems = data.items
        this.notes = data.notes
        this.paymentHistory = data.payments
        Object.assign(this.initInvoiceItems, this.invoiceItems)

        this.loaded = true
        this.dialog = true
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to get detail',
          error: resp.data.detail || resp.statusText
        })
      })
  }
}
</script>

<style lang="scss">
.active-account {
  border-left: 2px solid blue;
}
.invoice-dialog {
  position: fixed;
  margin: 0;
  width: auto;
  top: 0; left: 20%; bottom: 0; right: 0;
  max-height: 100% !important;
  @media screen and (max-width: 600px) {
    left: 10%;
  }
}
.invoice-dialog-card {
  border-radius: 0 !important;
  position: absolute;
  top: 64px; bottom: 0;
  left: 0; right: 0;
  @media screen and (max-width: 960px) {
    top: 56px;
  }
}
.invoice-form .v-input--checkbox {
  margin-left: 16px;
}
.invoice-input {
  margin-top: -13px;
  font-size: 1em;
  min-width: 74px;
}
.customer-info {
  border: 1px solid #bbb;
  border-top: 0;
  margin:-19px -10px;
  border-radius:0 0 5px 5px;
  padding: 16px;
  height: 109px
}
</style>
